import {
    deleteEvent,
    deleteCompoundEvent
} from 'session/operations/actions.js';
import {ARRANGEMENT_TRACK_PATTERN} from 'session/constants.js';
import {
    deleteRowSelections,
    copy,
    paste,
    isRowSelectionsEmpty,
    duplicate} from './copy.js';
import {
    setSelectedArrangementEvents,
    setArrangementCursorStep,
    setArrangementSelectedRows,
    setArrangementPatternSelected} from 'actions/index.js';
import {
    NO_SUB_SEQUENCE,
    PATTERN_SWITCH,
    SEQUENCE_ROLL,
    RESOLUTION_CHANGE} from 'session/constants.js';

export const arrangementBackspace = (engine) => {
    let state = engine.state;
    let rowSelections = state.arrangement.rowSelections;
    if (!isRowSelectionsEmpty(rowSelections)) {
        deleteRowSelections(engine, rowSelections);
        return;
    }
    let selectedEvents = state.arrangement.selectedEvents;
    let selectedRows = state.arrangement.selectedRows;

    if (selectedRows === undefined ||
        selectedRows.length === 0) {
        return;
    }

    let id = selectedRows[0];
    for (let i in selectedEvents) {
        let type = parseInt(i);
        let event = selectedEvents[i];
        if (type  === ARRANGEMENT_TRACK_PATTERN) {
            deletePattern(engine, event);
            continue;
        }
        let mix = getMix(engine, id);
        if (event.parentEvent !== undefined) {
            mix.dispatch(deleteCompoundEvent(event.parentEvent, event));
        } else {
            mix.dispatch(deleteEvent(event, true));
        }
    }
    engine.dispatch(
        setSelectedArrangementEvents(undefined));
};

export const arrangementArrowLeft = (sequencerEngine) => {
    let event = getSelected(sequencerEngine.state);
    if (!event) {
        return undefined;
    }

    let {mix} = event.subSequence;
    if (!mix) {
        return undefined;
    }
    let prevEvent = mix.getPreviousEvent(event);
    if (prevEvent) {
        return selectEvent(sequencerEngine, prevEvent);
    }
};

export const arrangementArrowRight = (sequencerEngine) => {
    let event = getSelected(sequencerEngine.state);
    if (!event) {
        return;
    }
    let {mix} = event.subSequence;
    if (!mix) {
        return undefined;
    }
    let nextEvent = mix.getNextEvent(event);
    if (nextEvent) {
        return selectEvent(sequencerEngine, nextEvent);
    }
};

const selectEvent = (sequencerEngine, event) => {
    let events = {};
    events[event.id] = event;
    sequencerEngine.dispatch(
        setSelectedArrangementEvents(events));
    if (sequencerEngine.state.arrangement.patternSelected) {
        sequencerEngine.dispatch(
            setArrangementPatternSelected(event));
    }

    sequencerEngine.dispatch(
        setArrangementCursorStep(event.step));
};

const getSelected = (state) => {
    let events = state.arrangement.selectedEvents;
    if (!events || Object.keys(events).length === 0) {
        return undefined;
    }

    let event = events[Object.keys(events)[0]];
    return event;
};

const getMix = (engine, subSequenceId) => {
    if (subSequenceId === NO_SUB_SEQUENCE.id) {
        return engine.mix;
    }
    return engine
        .getSubSequence(subSequenceId)
        .mix;
}

const deletePattern = (engine, pattern) => {
        // first check if theres any piano roll steps selected
    // and cancel delete if there are any
    let pianoRollState = engine.state.keyboard;
    let {selectedPianoRollSteps} = pianoRollState;
    if (selectedPianoRollSteps !== undefined) {
        return;
    }
    
    // then delete them
    let {track} = pattern;
    let i = track.patterns.indexOf(pattern);
    track.deletePattern(i);
    engine.switchToPattern(0);
    track.updateSteps();
    engine.dispatch(setArrangementSelectedRows([]));
}

